import React, { useContext } from 'react';
import { ThemeContext } from '../theme/theme';

export default function Header({ onToggleSidebar }) {
  const { dark, setDark } = useContext(ThemeContext);

  return (
    <header style={styles.header}>
      {/* Left: Menu */}
      <div style={styles.left}>
        <button style={styles.button} onClick={onToggleSidebar}>☰ Menu</button>
      </div>

      {/* Center: Clear Custom */}
      <div>
        <button
          style={styles.button}
          onClick={() => {
            if (window.confirm('Are you sure you want to clear all custom playlists?')) {
              localStorage.removeItem('custom_playlists');
              window.location.reload();
            }
          }}
        >
          🗑 Clear Custom
        </button>
      </div>

      {/* Right: Refresh + Theme */}
      <div style={styles.right}>
        <button style={styles.button} onClick={() => window.location.reload()}>🔄 Refresh</button>
        <button style={styles.button} onClick={() => setDark(!dark)}>
          {dark ? '🌞 Light' : '🌙 Dark'}
        </button>
      </div>
    </header>
  );
}

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 15px',
    backgroundColor: 'var(--card-bg)',
    color: 'var(--accent-color)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    height: '60px',
    width: '100%',
    boxSizing: 'border-box',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  button: {
    background: 'transparent',
    border: '2px solid var(--accent-color)',
    color: 'var(--accent-color)',
    borderRadius: '20px',
    padding: '6px 12px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
};
